/**
 * `/shop/<slug>` — a vendor's public front door, and the root of every public URL they own
 * (TRO-1187).
 *
 * The same screen as `/inventory/<slug>` and `/shops/<slug>`, which both keep resolving: the first
 * is what printed label QR codes redirect to (`shop_inventory_item_url`) and the second is the
 * link TRO-1153 shipped. One screen at three paths rather than three screens, so the storefront
 * cannot drift between the URL a customer arrived on.
 */
export { default } from "../../inventory/[slug]";
